import { ErrorHandler, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { DetailBase } from '../../core/structures';
import { Contractor } from '../models';
import { ContractorService } from '../services/contractor.service';

export class NewContractorBaseComponent extends DetailBase<Contractor> implements OnInit, OnChanges {

    Contractor = new Contractor();

    constructor(
        private api: ContractorService,
        private errorHandler: ErrorHandler
    ) {
        super({ api, errorHandler });
    }

    ngOnChanges(changes: SimpleChanges): void {
    }

    ngOnInit() {
    }
}
